/* V2  - Video Container Actions Buttons */

import * as React from "react";
import LocalStorageUtils from "../../utils/LocalStorageUtils";
import {EventNames} from "../../utils/EventTrackerConstants";

interface VideoCallActionBarProps {
    isMute: boolean;
    isVideoOff: boolean;
    isDisconnected: boolean;
    phoneButtonClicked: (e?: any) => void;
    muteToggleButtonClicked: (e?: any) => void;
    videoToggleButtonClicked: (e?: any) => void;
    hangupButtonClicked: (e?: any) => void;
    completeConsultationButtonClicked: (e?: any) => void;
    disconnectCall(): void;
    connectCall(): void;
}

interface VideoCallActionBarState {
    shouldShowLoader: boolean
}

export class VideoCallActionBar extends React.Component<VideoCallActionBarProps, VideoCallActionBarState> {
    constructor(props: VideoCallActionBarProps) {
        super(props);
        this.state = {
            shouldShowLoader: false
        };
        this.disconnectCall = this.disconnectCall.bind(this);
        this.rejoinCall = this.rejoinCall.bind(this);
    }

    private disconnectCall(): void {
        this.props.disconnectCall();
        this.setState({ shouldShowLoader: true });

    }

    private rejoinCall():void {
        LocalStorageUtils.setClickEvents({ field: "Join Call", section: EventNames.Call_Widget,  widget: "Video Call" })
        this.props.connectCall();
        this.setState({ shouldShowLoader: true });

    }
    componentWillReceiveProps(nextProps: VideoCallActionBarProps) {
        if (nextProps.isDisconnected !== this.props.isDisconnected) {
            this.setState({ shouldShowLoader: false });
        }
    }
    render() {
        const { isDisconnected, isMute, muteToggleButtonClicked, videoToggleButtonClicked, isVideoOff } = this.props;
        const { shouldShowLoader } = this.state;
        return (<div className="video-call-container-action-bar">
            {!isDisconnected && !shouldShowLoader &&
                <div style={{ display: "inline-block" }}>
                    <div className="action-item" onClick={muteToggleButtonClicked}>
                        {isMute && <img src="/images/icons/disable-audio.png" />}
                        {!isMute && <img src="/images/icons/enable-audio.png" />}
                    </div>
                    <div className="action-item">
                        <img src="/images/dismiss-call.png" onClick={this.disconnectCall} />
                    </div>

                    <div className="action-item" onClick={videoToggleButtonClicked}>
                        {isVideoOff && <img src="/images/icons/disable-video.png" />}
                        {!isVideoOff && <img src="/images/icons/enable-video.png" />}
                    </div>
                </div>
            }
            {shouldShowLoader && <div className="action-item">
                <div className="loader"></div>
            </div>}
            {isDisconnected && !shouldShowLoader &&
                <button className="rejoin-call" onClick={this.rejoinCall}>Rejoin</button>
            }
        </div>
        );
    }
};

export default VideoCallActionBar
